module.exports = __webpack_public_path__ + "img/icon-arrow-down.b9c04d1b.svg";